// extracted by mini-css-extract-plugin
export default {"dealerBlock":"OrderDateDealerCode_dealerBlock__DiUY3","dillerCode":"OrderDateDealerCode_dillerCode__+bkuM","loader":"OrderDateDealerCode_loader__JjT-x"};